import React, { useCallback, useState } from 'react';
import dynamic from 'next/dynamic';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {
  MenuIconButton,
  DrawerMenuSwipeableDrawer,
  ButtonName,
} from './styles';

interface DrawerMenuProps {
  openDrawer?: boolean;
  isFromMenuName?: string;
}

const DrawerMenuContent = dynamic<{ handleCloseDrawer: () => void }>(
  () => import('./DrawerMenuContent').then((mod) => mod.DrawerMenuContent),
  {
    ssr: false,
    loading: () => null,
  },
);

export function DrawerMenu({ isFromMenuName }: DrawerMenuProps) {
  const [toggleDrawer, setToggleDrawer] = useState(false);

  const handleCloseDrawer = useCallback(() => {
    setToggleDrawer(false);
  }, []);
  const handleOpenDrawer = useCallback(() => {
    setToggleDrawer(true);
  }, []);

  return (
    <div>
      {!isFromMenuName ? (
        <MenuIconButton
          onClick={handleOpenDrawer}
          edge="start"
          color="inherit"
          aria-label="menu"
        >
          <MenuRoundedIcon />
        </MenuIconButton>
      ) : (
        <ButtonName onClick={handleOpenDrawer}>{isFromMenuName}</ButtonName>
      )}
      <DrawerMenuSwipeableDrawer
        anchor={'left'}
        open={toggleDrawer}
        onClose={handleCloseDrawer}
        onOpen={handleOpenDrawer}
      >
        {toggleDrawer && (
          <DrawerMenuContent handleCloseDrawer={handleCloseDrawer} />
        )}
      </DrawerMenuSwipeableDrawer>
    </div>
  );
}
